/**
 * The public keys this build of the SDK will accept licence signatures from.
 *
 * **This file contains public keys only.** BroadPaper's private signing key
 * lives in the licence issuer's secret store and is never in this repository,
 * never in the npm package and never in a browser bundle. Publishing the
 * public half is the point: it is what lets a licence be checked with no
 * network call.
 *
 * Add a production key with:
 *
 *     node scripts/licence-keys.mjs --production --key-id bp-1
 *
 * which prints the private key once, for the operator to paste into the
 * issuer's configuration, and writes the public half into this array.
 *
 * The list is an allowlist, so it is also the rotation mechanism: issue with a
 * new `keyId`, ship an SDK release trusting both, and drop the old entry once
 * every licence signed with it has expired. Licences carry their `keyId` inside
 * the signed payload, so an attacker cannot point one at a different key.
 *
 * It starts empty on purpose. A key here is trusted by every copy of the SDK in
 * the world, including production installs, which is exactly why a development
 * key must never be added to it — development keys are supplied at runtime
 * instead, through `configure({ trustedKeys })` or `BROADPAPER_TRUSTED_KEYS`,
 * so a licence signed in development cannot be honoured by a production build.
 */
import type { TrustedKey } from "./types.js";

export const TRUSTED_KEYS: readonly TrustedKey[] = [
  { keyId: "bp-2026", publicKey: "woKmWyIazae7SpGhi4dwA7zNK1lWdboq88Rl5xscTs4", note: "production, generated 2026-09-08" }
];
